module.exports = __webpack_public_path__ + "img/tg.29fa137c.svg";